import React, { useMemo, useState, useEffect } from "react";
import "./Home.css";
import { useSEO } from "../components/SEO";

import heroImg from "../assets/hero-bg.webp";
import heroMobileImg from "../assets/hero bg mobile.webp";

// ✅ scroll gif (for services section)
import scrollGif from "../assets/scroll.gif";

// carousel images
import rollerImg from "../assets/roller.webp";
import CustomisedRoller from "../assets/customized-roller.webp";
import motorizedImg from "../assets/motorized.webp";
import verticalImg from "../assets/vertical.webp";
import pvcExteriorImg from "../assets/pvc exterior.webp";
import zebraImg from "../assets/zebra.webp";

// TEMP placeholders (change later)
import extra1 from "../assets/customized.jpeg";
import extra2 from "../assets/bamboo.webp";
import extra3 from "../assets/venetian.webp";
import extra4 from "../assets/wooden.webp";
import extra5 from "../assets/industrial.webp";

// ✅ NEW SECTION images
import expertiseLeftImg from "../assets/1.webp";

import iconConsultation from "../assets/idea.webp";
import iconCustom from "../assets/catlge.webp";
import iconMeasure from "../assets/ruler.webp";
import iconInstall from "../assets/tools.webp";
import iconQuality from "../assets/safety.webp";
import iconSupport from "../assets/support.webp";

function Home() {
  useSEO({
    title:
      "A-Z Blinds | Premium Window Blinds Hyderabad – Roller, Zebra, Vertical & Motorized",
    description:
      "A to Z Blinds Hyderabad – 35+ years of trusted blinds. Roller blinds, zebra blinds, vertical blinds, motorized blinds, PVC exterior & custom printed blinds. Free consultation, 3-day service. Contact for quotes.",
    keywords:
      "blinds Hyderabad, window blinds Hyderabad, roller blinds, zebra blinds, vertical blinds, venetian blinds, motorized blinds, PVC exterior blinds, wooden blinds, bamboo blinds, custom blinds, A to Z Blinds, atozblinds, window coverings Hyderabad, made to measure blinds",
  });

  // ✅ Top circle carousel items (11)
  const items = useMemo(
    () => [
      { title: "Roller", img: rollerImg },
      { title: "Customized Roller", img: CustomisedRoller },
      { title: "Motorized Roller", img: motorizedImg },
      { title: "Vertical", img: verticalImg },
      { title: "PVC exterior", img: pvcExteriorImg },
      { title: "zebra", img: zebraImg },

      // extra
      { title: "Customized Zebra", img: extra1 },
      { title: "Bamboo", img: extra2 },
      { title: "Venetian", img: extra3 },
      { title: "Wooden", img: extra4 },
      { title: "Industrial", img: extra5 },
    ],
    []
  );

  // ✅ Services (sticky-collection) cards (same as Services page)
  const servicesCollection = useMemo(
    () => [
      {
        title: "Roller Blinds",
        img: rollerImg,
        desc:
          "Sleek and minimal blinds for modern interiors.\nSmooth light control with effortless functionality.",
      },
      {
        title: "Customized\nRoller Blinds",
        img: CustomisedRoller,
        desc:
          "Roller blinds with high-quality custom image printing.\nAdd personal photos, artwork, or business branding to your windows.",
      },
      {
        title: "PVC Exterior\nBlinds",
        img: pvcExteriorImg,
        desc:
          "Durable outdoor protection from heat and dust.\nBuilt strong for balconies and exterior spaces.",
      },
      {
        title: "Motorised Roller\nBlinds",
        img: motorizedImg,
        desc:
          "Smart blinds controlled with a touch.\nConvenience, comfort, and modern automation.",
      },
      {
        title: "Vertical Blinds",
        img: verticalImg,
        desc:
          "Ideal for large windows and sliding doors.\nStructured design with easy light adjustment.",
      },
      {
        title: "Zebra Blinds",
        img: zebraImg,
        desc:
          "Dual-layer design for flexible light and privacy control.\nA contemporary touch with stylish functionality.",
      },
      {
        title: "Customized\nZebra Blinds",
        img: extra1,
        desc:
          "Zebra blinds with custom-designed printed layers.\nUnique visuals combined with flexible light control.",
      },
      {
        title: "Venetian Blinds",
        img: extra3,
        desc:
          "Classic horizontal slats for adjustable lighting.\nTimeless design that suits every interior.",
      },
      {
        title: "Wooden Blinds",
        img: extra4,
        desc:
          "Natural wood finish for a warm interior feel.\nPremium elegance with lasting durability.",
      },
      {
        title: "Bamboo Blinds",
        img: extra2,
        desc:
          "Eco-friendly design with earthy charm.\nSoft light filtering for relaxed spaces.",
      },
      {
        title: "Industrial Blinds",
        img: extra5,
        desc:
          "Heavy duty blinds built for large spaces.\nReliable performance with clean aesthetics.",
      },
    ],
    []
  );

  const ITEM_SIZE = 170;
  const GAP = 60;

  // ✅ responsive visible count (desktop/tab same)
  const [visible, setVisible] = useState(6);
  const [isMobile, setIsMobile] = useState(false);

  const [isHeroMobile, setIsHeroMobile] = useState(false);

useEffect(() => {
  const mq = window.matchMedia("(max-width: 768px)");

  const updateHero = () => setIsHeroMobile(mq.matches);
  updateHero();

  // ✅ works in all modern browsers
  if (mq.addEventListener) mq.addEventListener("change", updateHero);
  else mq.addListener(updateHero); // ✅ fallback

  return () => {
    if (mq.removeEventListener) mq.removeEventListener("change", updateHero);
    else mq.removeListener(updateHero);
  };
}, []);

  useEffect(() => {
    const updateVisible = () => {
      const w = window.innerWidth;

      // ✅ Mobile + Tablet/iPad => swipe mode
      if (w <= 1200) {
        setIsMobile(true);
        setVisible(2); // visible is not used in swipe mode, keep any safe value
      } else {
        // ✅ Desktop => arrows mode
        setIsMobile(false);
        setVisible(6);
      }
    };

    updateVisible();
    window.addEventListener("resize", updateVisible);
    return () => window.removeEventListener("resize", updateVisible);
  }, []);

  // ✅ Desktop/Tab carousel logic (keep EXACT as you had)
  const [index, setIndex] = useState(0);

  const maxIndex = Math.max(0, items.length - visible);

  useEffect(() => {
    setIndex((prev) => Math.min(prev, maxIndex));
  }, [maxIndex]);

  const handlePrev = () => setIndex((prev) => Math.max(0, prev - 1));
  const handleNext = () => setIndex((prev) => Math.min(maxIndex, prev + 1));

  const translateX = -(index * (ITEM_SIZE + GAP));

  return (
    <div className="home">
      {/* HERO */}
      {/* HERO */}
<section
  className="hero"
  style={{
    backgroundImage: `url(${isHeroMobile ? heroMobileImg : heroImg})`,
  }}
>
  <div className="hero__overlay" />
  <div className="hero__content">
    <div className="hero__text">
      <h1 className="hero__title">
        Redefining Windows,
        <br />
        One Blind at a Time.
      </h1>

      <p className="hero__subtitle">
        A complete range of sophisticated window blinds –
        <br />
        designed to control light, enhance privacy, and elevate interiors.
      </p>
    </div>
  </div>
</section>

      {/* CAROUSEL */}
      <section className="category category--desktopGutter">
        {/* ✅ DESKTOP arrows */}
        {!isMobile && (
          <button
            className="arrow arrow--left"
            onClick={handlePrev}
            disabled={index === 0}
            aria-label="Previous"
            type="button"
          >
            ‹
          </button>
        )}

        {/* ✅ MOBILE = native scroll */}
        {isMobile ? (
          <div className="category__viewport category__viewport--mobile">
            <div className="category__track category__track--mobile">
              {items.map((item, i) => (
                <div className="category__item" key={`${item.title}-${i}`}>
                  <div
                    className="category__circle"
                    style={{ width: ITEM_SIZE, height: ITEM_SIZE }}
                  >
                    <img src={item.img} alt={item.title} />
                  </div>
                  <p className="category__label">{item.title}</p>
                </div>
              ))}
            </div>
          </div>
        ) : (
          /* ✅ DESKTOP = clipped viewport (no peek near arrows) */
          <div className="category__viewport category__viewport--desktop">
            <div
              className="category__track"
              style={{ transform: `translateX(${translateX}px)` }}
            >
              {items.map((item, i) => (
                <div className="category__item" key={`${item.title}-${i}`}>
                  <div
                    className="category__circle"
                    style={{ width: ITEM_SIZE, height: ITEM_SIZE }}
                  >
                    <img src={item.img} alt={item.title} />
                  </div>
                  <p className="category__label">{item.title}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {!isMobile && (
          <button
            className="arrow arrow--right"
            onClick={handleNext}
            disabled={index === maxIndex}
            aria-label="Next"
            type="button"
          >
            ›
          </button>
        )}

        {/* ✅ caption */}
        <p className="category__caption">
          Made to measure blinds for modern homes and workspaces.
        </p>
      </section>

      {/* ✅ EXPERTISE SECTION */}
      <section className="expertise">
        {/* ✅ MOBILE heading ABOVE image (desktop hidden via CSS) */}
        <div className="expertise__mobileHead">
          <h2 className="expertise__title">
            Your Vision
            <br />
            Our Expertise
          </h2>
          <p className="expertise__subtitle">From consultation to installation.</p>
        </div>

        <div className="expertise__wrap">
          <div className="expertise__left">
            <img src={expertiseLeftImg} alt="Blinds installation" />
          </div>

          <div className="expertise__right">
            {/* ✅ DESKTOP/TAB heading (mobile hidden via CSS) */}
            <h2 className="expertise__title expertise__desktopHead">
              Your Vision
              <br />
              Our Expertise
            </h2>

            <p className="expertise__subtitle expertise__desktopHead">
              From consultation to installation.
            </p>

            {/* ✅ Cards container */}
            <div className="expertise__grid expertise__stack">
              <div className="expertise__item">
                <div className="expertise__icon">
                  <img src={iconConsultation} alt="Expert Consultation" />
                </div>
                <div>
                  <h4>Expert Consultation</h4>
                  <p>Personalized guidance for your space.</p>
                </div>
              </div>

              <div className="expertise__item">
                <div className="expertise__icon">
                  <img src={iconCustom} alt="Custom Solutions" />
                </div>
                <div>
                  <h4>Custom Solutions</h4>
                  <p>Tailored designs &amp; materials</p>
                </div>
              </div>

              <div className="expertise__item">
                <div className="expertise__icon">
                  <img src={iconMeasure} alt="Precise Measurement" />
                </div>
                <div>
                  <h4>Precise Measurement</h4>
                  <p>Accurate, on-site assessment</p>
                </div>
              </div>

              <div className="expertise__item">
                <div className="expertise__icon">
                  <img src={iconInstall} alt="Professional Installation" />
                </div>
                <div>
                  <h4>Professional Installation</h4>
                  <p>Clean, efficient execution</p>
                </div>
              </div>

              <div className="expertise__item">
                <div className="expertise__icon">
                  <img src={iconQuality} alt="Quality Assurance" />
                </div>
                <div>
                  <h4>Quality Assurance</h4>
                  <p>Premium materials, lasting results,</p>
                </div>
              </div>

              <div className="expertise__item">
                <div className="expertise__icon">
                  <img src={iconSupport} alt="After-Sales Support" />
                </div>
                <div>
                  <h4>After-Sales Support</h4>
                  <p>We’re here even after install</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ STATS SECTION */}
      <section className="stats">
        <div className="stats__wrap">
          <div className="stats__row">
            <div className="stats__grid">
              <div className="stats__item">
                <h2>
                  3 <span>DAYS</span>
                </h2>
                <p>Fast, efficient service within 3 Days</p>
              </div>

              <div className="stats__item">
                <h2>
                  35+ <span>YEARS</span>
                </h2>
                <p>35 years of trusted service</p>
              </div>

              <div className="stats__item">
                <h2>70%</h2>
                <p>Repeat Customers. long-term relationships</p>
              </div>

              <div className="stats__item">
                <h2>500+</h2>
                <p>Extensive Design styles, colors, and materials</p>
              </div>
            </div>

            <div className="stats__text">
              <p>
                For over three decades, A to Z Blinds has been transforming homes and
                workspaces with precision-crafted window solutions. Our commitment to
                quality, timely delivery and customer satisfaction has made us a
                trusted name across generations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ SERVICES (sticky-collection) SECTION — inserted after stats */}
      <section className="sticky-collection">
        <div className="sticky-collection__wrap">
          <div className="sticky-collection__head">
            <h1 className="sticky-collection__title">Explore Our Blinds Collection</h1>
            <p className="sticky-collection__sub">
              Modern designs. Smart functionality. Premium materials.
            </p>

            <div className="sticky-collection__scroll">
              <span>Scroll</span>
              <img
                className="sticky-collection__scrollGif"
                src={scrollGif}
                alt="Scroll down"
              />
            </div>
          </div>

          <div className="sticky-collection__grid">
            {servicesCollection.map((c, i) => (
              <div className="sticky-cardWrap" key={`${c.title}-${i}`}>
                <div className="sticky-card">
                  <img src={c.img} alt={c.title.replace(/\n/g, " ")} />

                  <div className="sticky-card__label">
                    <h3 style={{ whiteSpace: "pre-line" }}>{c.title}</h3>
                  </div>

                  <div className="sticky-card__overlay">
                    <h3 style={{ whiteSpace: "pre-line" }}>{c.title}</h3>
                    <p style={{ whiteSpace: "pre-line" }}>{c.desc}</p>
                  </div>
                </div>

                <div className="sticky-cardText">
                  <h3 style={{ whiteSpace: "pre-line" }}>{c.title}</h3>
                  <p style={{ whiteSpace: "pre-line" }}>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ GALLERY + REVIEWS SECTION (as per Figma) */}
      <section className="reviewsBlock">
        <div className="reviewsBlock__wrap">
          <h2 className="reviewsBlock__galleryTitle">View Our Installed Blinds Gallery</h2>
          <button className="reviewsBlock__galleryBtn" type="button">
            View More
          </button>

          <div className="reviewsBlock__divider" />

          {/* ✅ MOBILE/TAB: Title first + ONE swipe carousel with ALL cards */}
          <div className="testimonialsMobile">
            <div className="testimonialsMain__center">
              <h2 className="testimonialsMain__title">
                Trusted by Hundreds <br /> of Happy Customers
              </h2>

              <p className="testimonialsMain__sub">
                We value every project and every client relationship.
                <br />
                Here’s what our customers say about their experience
                <br />
                with A to Z Blinds.
              </p>

              <p className="testimonialsMain__google">Hundreds of Reviews On Google</p>

              <div className="testimonialsMain__rating">
                <span className="testimonialsMain__ratingText">With 4.8</span>
                <span className="testimonialsMain__stars">★★★★★</span>
              </div>

              <button className="testimonialsMain__btn" type="button">
                View More
              </button>
            </div>

            <div className="testimonialsMain__track">
              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Found this shop on google, the entire process of selection, ordering and
                  installation was done within a week. I did not even have to visit the shop
                  once. All details were shared on whatsapp and questions handled promptly.
                  Very happy with the product and service.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Mitali Giri</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Best quality and designs with reasonable prices. Quick installation and
                  best service. 👍👍
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">AISHWARYA G</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Excellent design service and installation service. They made everything
                  very easy and professionally. I am extremely happy with the final product.
                  I highly recommend them!
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Mohammed Arif</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Good service , In time delivery and installation. So happy with the product
                  and quality.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Dande Nithin</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  My house has been got a new look with these blinds and changed entire
                  look. Feeling good. Thank you for your service and quick response.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">David Raj</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Our office have been New look after these blinds. Thank you for your
                  best service.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Madhu sudhan</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Order on Thursday. Fittings done by Saturday. Smooth and no hassle at
                  all. High quality work.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Arjun Somayajula</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  I like the product and quality of blinds is good. With 2 years of
                  warranty, best deal I have received compare to other vendors.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Sukeerth Kumar</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ DESKTOP ORIGINAL (KEEP EXACTLY) */}
          <div className="reviewsTopRow">
            <div className="reviewCard reviewCard--top">
              <div className="reviewCard__quote">“</div>
              <p className="reviewCard__text">
                Found this shop on google, the entire process of selection, ordering and
                installation was done within a week. I did not even have to visit the shop
                once. All details were shared on whatsapp and questions handled promptly.
                Very happy with the product and service.
              </p>
              <div className="reviewCard__footer">
                <span className="reviewCard__name">Mitali Giri</span>
                <span className="reviewCard__stars">★★★★★</span>
              </div>
            </div>

            <div className="reviewCard reviewCard--top">
              <div className="reviewCard__quote">“</div>
              <p className="reviewCard__text">
                Best quality and designs with reasonable prices. Quick installation and
                best service. 👍👍
              </p>
              <div className="reviewCard__footer">
                <span className="reviewCard__name">AISHWARYA G</span>
                <span className="reviewCard__stars">★★★★★</span>
              </div>
            </div>

            <div className="reviewCard reviewCard--top">
              <div className="reviewCard__quote">“</div>
              <p className="reviewCard__text">
                Excellent design service and installation service. They made everything
                very easy and professionally. I am extremely happy with the final product.
                I highly recommend them!
              </p>
              <div className="reviewCard__footer">
                <span className="reviewCard__name">Mohammed Arif</span>
                <span className="reviewCard__stars">★★★★★</span>
              </div>
            </div>

            <div className="reviewCard reviewCard--top">
              <div className="reviewCard__quote">“</div>
              <p className="reviewCard__text">
                Good service , In time delivery and installation. So happy with the product
                and quality.
              </p>
              <div className="reviewCard__footer">
                <span className="reviewCard__name">Dande Nithin</span>
                <span className="reviewCard__stars">★★★★★</span>
              </div>
            </div>
          </div>

          <div className="testimonialsMain">
            <div className="testimonialsMain__col testimonialsMain__col--desktop">
              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  My house has been got a new look with these blinds and changed entire
                  look. Feeling good. Thank you for your service and quick response.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">David Raj</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Our office have been New look after these blinds. Thank you for your
                  best service.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Madhu sudhan</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>
            </div>

            <div className="testimonialsMain__center">
              <h2 className="testimonialsMain__title">
                Trusted by Hundreds <br /> of Happy Customers
              </h2>

              <p className="testimonialsMain__sub">
                We value every project and every client relationship.
                <br />
                Here’s what our customers say about their experience
                <br />
                with A to Z Blinds.
              </p>

              <p className="testimonialsMain__google">Hundreds of Reviews On Google</p>

              <div className="testimonialsMain__rating">
                <span className="testimonialsMain__ratingText">With 4.8</span>
                <span className="testimonialsMain__stars">★★★★★</span>
              </div>

              <button className="testimonialsMain__btn" type="button">
                View More
              </button>
            </div>

            <div className="testimonialsMain__col testimonialsMain__col--desktop">
              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  Order on Thursday. Fittings done by Saturday. Smooth and no hassle at
                  all. High quality work.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Arjun Somayajula</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>

              <div className="reviewCard">
                <div className="reviewCard__quote">“</div>
                <p className="reviewCard__text">
                  I like the product and quality of blinds is good. With 2 years of
                  warranty, best deal I have received compare to other vendors.
                </p>
                <div className="reviewCard__footer">
                  <span className="reviewCard__name">Sukeerth Kumar</span>
                  <span className="reviewCard__stars">★★★★★</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;